import React, { useState, useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"

import { getClientEmailTemplates } from "../../state/clientEmailsSlice"
import EmailTemplate from "./EmailTemplate"
import { Link } from "react-router-dom"

function ClientEmails() {

    let dispatch = useDispatch();

    let welcomeEmailBody = useSelector(state => state.clientEmails.welcomeEmail.email_body)

    useEffect(() => {
        dispatch(getClientEmailTemplates({email_type_id:"1"}))
    }, [])


    return (
        <>
            <Link to="/Settings" > Settings </Link> / Email Customization
            <h1 className="my-4">
                Email Customization
            </h1>
            <hr/>

            {/* email variable insert options */}
            <EmailTemplate isLoadingEmamil={useState(true)} emailBody={welcomeEmailBody}/>
        </>

    )
}

export default ClientEmails